import { DATE_TIME_FORMAT_SECONDS } from 'utils/constants/dateTime';
import { convertUtcToDisplayTime } from 'utils/helpers/dateTime';
import i18n from 'i18n';

export const DumpingTimeLineChartTooltip = ({
  seriesIndex,
  dataPointIndex,
  w,
  isMarginTop = false,
  preferredTimeDisplayMode,
  timezone,
}: any): string => {
  const dataPoint = w.globals.initialSeries[seriesIndex].data[dataPointIndex];

  const startLoc = dataPoint?.extraDetails?.startLocation;
  const startLocation = startLoc === 'D' ? '' : `Site ${startLoc}`;
  const start = dataPoint?.extraDetails?.start;
  const end = dataPoint?.extraDetails?.end;
  const bumperNumber = dataPoint?.extraDetails?.bumperNumber;
  const rawMaterialDumped = dataPoint?.extraDetails?.material_dumped;
  const seriesColor = w.globals.colors[seriesIndex];
  const title = dataPoint.x; // Include the title
  const startTime = convertUtcToDisplayTime(
    start,
    preferredTimeDisplayMode,
    timezone,
    DATE_TIME_FORMAT_SECONDS
  );
  const endTime = convertUtcToDisplayTime(
    end,
    preferredTimeDisplayMode,
    timezone,
    DATE_TIME_FORMAT_SECONDS
  );
  const materialDumped =
    typeof rawMaterialDumped === 'number'
      ? parseFloat(rawMaterialDumped.toFixed(2))
      : 0;

  return `
        <div style="
          background: #2E3B4E; 
          color: #FFFFFF; 
          padding: 12px; 
          border-radius: 8px; 
          font-family: Arial, sans-serif; 
          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2); 
          max-width: 200px;
          ${isMarginTop ? 'margin-top: 80px;' : ''}
          ">
          <div style="font-weight: bold; font-size: 14px; margin-bottom: 8px; text-align: center; color: white;">
            ${title}
          </div>
          <div style="font-size: 12px; margin-bottom: 4px; text-transform: capitalize;">
            <span style="color: ${seriesColor}; font-weight: bold;">${i18n.t(
    'tooltip_event'
  )}:</span> ${bumperNumber} - ${startLocation}
          </div>
             <div style="font-size: 12px; margin-bottom: 4px; text-transform: capitalize;">
            <span style="color: ${seriesColor}; font-weight: bold;">${i18n.t(
    'tooltip_material_dumped'
  )}:</span>${materialDumped} ${i18n.t('tooltip_tons')}
          </div>
          ${`
          <div style="font-size: 12px; margin-bottom: 4px;">
            <span style="color: ${seriesColor}; font-weight: bold;">${i18n.t(
            'tooltip_start'
          )}</span> ${startTime}
          </div>
          <div style="font-size: 12px; margin-bottom: 4px;">
            <span style="color: ${seriesColor}; font-weight: bold;">${i18n.t(
            'tooltip_end'
          )}</span> ${endTime}
          </div>
          `}
        </div>
      `;
};
